import { SettingsMeta } from './business-setting-add';

export interface BusinessResponsibleOptionsDto {
  UserId: number;
  IsResponsibleForExecution: boolean;
  IsResponsibleForFollowup: boolean;
}

export class BusinessSettingViewDto {
  Id: number;
  BusinessId?: number | null;
  LanguageId?: number | null;
  ThemeId?: number | null;
  HseGoal?: string | null;
  HseManagerKey?: number | null;
  EnvironmentallighthouseKey?: number | null;
  HseFeatureId?: number | null;
  HseAdviserKey?: number | null;
  BusinessLogo?: string | null;
  BusinessImg?: string | null;
  InsuranceCompany?: string | null;
  HomePageAddress?: string | null;
  IsSms?: boolean | null;
  IsEmail?: boolean | null;
  PortalContact?: number | null;
  FlexiCustomerActionPointResponsibleUserId?: number | null;
  FlexiCustomerActionPointResponsibleUserIds?: number[];
  CreatedBy?: number | null;
  CreatedOn?: string | null;
  ModifiedBy?: number | null;
  ModifiedOn?: string | null;
  CreatedUserRole?: number | null;
  BusinessPortalId?: number | null;
  SettingsMeta?: SettingsMeta[] | null;
  ResponsibleOptions?: BusinessResponsibleOptionsDto[] | null;
  ResponsibleForExecution: number[];
  ResponsibleForFollowup: number[];
  ResponsibleForAppraisal?: number[];
}
